import moment from 'moment';
import 'moment/locale/sv';

import {updateObject} from 'utils/reducerUtils';

const addMomentsToTestResult = (testResult) => {
	let {createdAt, distributedAt, usedAt, completedAt, isUsed} = testResult;

	createdAt = moment(createdAt);

	if (distributedAt) {
                distributedAt = moment(distributedAt).locale('sv');
        }

        if (isUsed && usedAt) {
                usedAt = moment(usedAt).locale('sv');
        }

        if (completedAt) {
                completedAt = moment(completedAt).locale('sv');        }
	return updateObject(testResult, {
		createdAt,
		distributedAt,
		usedAt,
		completedAt,
	});
};

export default function addMomentsToTestResults(testResults) {
	return testResults.map(addMomentsToTestResult);
}
